import React from "react";
import * as XLSX from "xlsx";
import Button from "../button/Button";

const ExportExcel = ({ jsonData, title, header }) => {
  const handleExport = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(jsonData, header ? { header } : undefined);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
  };

  return (
    <Button
      onClick={handleExport}
      text={title || "دانلود فایل اکسل"}
      color="success"
      type="button"
      className="whitespace-nowrap min-w-fit"
    />
  );
};

export default ExportExcel;
